import { render, staticRenderFns } from "./CelebrationSelector.vue?vue&type=template&id=2aa538d6&scoped=true"
import script from "./CelebrationSelector.vue?vue&type=script&lang=js"
export * from "./CelebrationSelector.vue?vue&type=script&lang=js"
import style0 from "./CelebrationSelector.vue?vue&type=style&index=0&id=2aa538d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa538d6",
  null
  
)

export default component.exports